import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  TerminalBulkUpdateRequest,
  TerminalBulkUpdateResponse,
  TerminalBulkDeleteRequest,
  TerminalBulkDeleteResponse,
} from './TerminalBulkService.types';

export class TerminalBulkService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  search(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(request: TerminalBulkUpdateRequest) {
    return this.instance.patch<TerminalBulkUpdateResponse>('/terminals', request.body);
  }

  delete(request: TerminalBulkDeleteRequest) {
    return this.instance.delete<TerminalBulkDeleteResponse>('/terminals', { data: request.body });
  }
}
